import { useEffect, useRef } from 'react';
import { scaleLinear } from 'd3-scale';

export function useScale(
    domain: [number, number] | undefined,
    fallbackDomain: [number, number] = [0, 1]
) {
    const actualDomain =
        domain && domain[0] !== domain[1] ? domain : fallbackDomain;
    const actualStart = actualDomain[0];
    const actualEnd = actualDomain[1];

    const scaleRef = useRef(scaleLinear());
    useEffect(() => {
        scaleRef.current.domain(actualDomain);
    }, [actualDomain, actualStart, actualEnd]);
    return scaleRef.current;
}
